import { Loader } from '@pocketlaw/tetris';
import { LoaderContainer } from './styled';
export function SidebarSectionLoader() {
    return (<LoaderContainer>
      <Loader size={16}/>
    </LoaderContainer>);
}
